import { ChevronDown } from "lucide-react";
import type { Ref, SelectHTMLAttributes } from "react";
import { cn } from "../../lib/cn";

interface NativeSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  ref?: Ref<HTMLSelectElement>;
  variant?: "field" | "toolbar";
}

export function NativeSelect({
  children,
  className,
  variant = "field",
  ...props
}: NativeSelectProps) {
  return (
    <span
      className={cn("relative", variant === "toolbar" ? "inline-flex w-fit max-w-full" : "block")}
    >
      <select
        className={cn(
          "peer type-label appearance-none rounded-(--radius-md) border pr-[calc(var(--space-3)+var(--space-4)+var(--space-2))] disabled:cursor-not-allowed disabled:text-(--color-text-tertiary) disabled:opacity-50 aria-[invalid=true]:border-(--color-danger)",
          variant === "toolbar"
            ? "h-(--control-h-sm) w-auto max-w-full cursor-pointer border-transparent bg-transparent pl-(--space-2) text-(--color-text-secondary) hover:bg-(--color-surface-2) hover:text-(--color-text)"
            : "h-(--field-h) w-full border-(--color-border) bg-(--color-surface) pl-(--space-3) text-(--color-text) hover:border-(--color-border-strong) disabled:bg-(--color-surface-2)",
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden="true"
        className="pointer-events-none absolute right-(--space-3) top-1/2 size-(--space-4) -translate-y-1/2 text-(--color-text-secondary) peer-disabled:opacity-50"
      />
    </span>
  );
}
